export default {
  methods: {
    /**
     * 事件分发
     * 
     * @param {any} name 组件名
     * @param {any} event 自定义事件名
     * @param {any} fn 回调
     * @param {any} curTarget 当前DOM对象
     */
    dispatch(name, event, fn, curTarget) {
      let parent = this.$parent || this.$root
      let curname = this.$parent.$options.name

      while (parent && (!curname || name !== curname)) {
        parent = parent.$parent
        if(parent) {
          curname = parent.$options.name
        }
      }
      
      parent.$emit(event, fn, curTarget)
    },
    /**
     * 事件广播
     * 
     * @param {any} name 组件名
     * @param {any} event 自定义事件名
     * @param {any} fn 回调
     * @param {any} curTarget 当前DOM对象
     */
    broadcast(name, event, fn, curTarget) {
      this.$children.forEach(function(child) {
        let curname = child.$options.name
        if(curname==name) {
          child.$emit(event, fn, curTarget)
        }else {
          this.broadcast.call(child, name, event, fn, curTarget)
        }
      }, this);
    }
  }
}


// WEBPACK FOOTER //
// ./~/iexplore/lib/unit.js